import { useCallback, useEffect, useState } from "react";

import { API_ENDPOINT } from "../constants";
import { ISubscription } from "../types";

export interface IUseGetSubscription {
  subscriptionId: string;
  subscriptionConfigurationToken: string;
}

export const useGetSubscription = (input: IUseGetSubscription) => {
  const [data, setData] = useState<ISubscription | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetch(`${API_ENDPOINT}/api/subscriptions/${input.subscriptionId}`, {
      headers: {
        "x-vestaboard-subscription-configuration-token":
          input.subscriptionConfigurationToken,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(setData)
      .then(() => setLoading(false));
  }, [input.subscriptionConfigurationToken, input.subscriptionId]);

  const updateSubscription = useCallback(
    async (subscription: ISubscription) => {
      setData(subscription);

      const res = await fetch(
        `${API_ENDPOINT}/api/subscriptions/${input.subscriptionId}`,
        {
          method: "POST",
          headers: {
            "x-vestaboard-subscription-configuration-token":
              input.subscriptionConfigurationToken,
            "content-type": "application/json",
          },
          // Save only reads cadence. Do not POST hydrated channel icons
          // (signed S3 URLs) or large pools 413 the default 100kb JSON limit.
          body: JSON.stringify({ cadence: subscription.cadence }),
        },
      );
      const payload = await res.json().catch(() => null);
      if (!res.ok) {
        throw new Error(
          payload?.message || payload?.error || `Save failed (${res.status})`,
        );
      }
      setLoading(false);
    },
    [input.subscriptionConfigurationToken, input.subscriptionId]
  );

  return {
    data,
    loading,
    updateSubscription,
  };
};
